/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbRespTradePromoDoublePoints_searchBrowse = {|
  +appliedFilters?: ?$ReadOnlyArray<?{|
    +name: ?string;
    +values: ?$ReadOnlyArray<?{|
      +urlLabel: ?string;
    |}>;
  |}>;
  +filters?: ?$ReadOnlyArray<?{|
    +name: ?string;
    +values: ?$ReadOnlyArray<?{|
      +link: ?string;
      +urlLabel: ?string;
    |}>;
  |}>;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespTradePromoDoublePoints_searchBrowse",
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParam",
          "name": "appliedFilters",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "name",
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "SearchBrowseParsedParamValue",
              "name": "values",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "urlLabel",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "SearchBrowseFilter",
          "name": "filters",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "name",
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "limit",
                  "value": 15,
                  "type": "Int"
                }
              ],
              "concreteType": "SearchBrowseFilterValue",
              "name": "values",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "link",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "urlLabel",
                  "storageKey": null
                }
              ],
              "storageKey": "values{\"limit\":15}"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "SearchBrowseQueryConnection"
};

module.exports = fragment;
